import * as React from 'react';
import { isBelowSidebarWidth } from './../../helpers/is-mobile';

interface IProps {
    visibleChildKey: string
    children: React.ReactElement<React.Props<any>>[]
    closeOverlays: () => void
    isMobile: boolean
}

export default class Sidebar extends React.Component<IProps> {
    private activeSidebarRef: React.RefObject<HTMLElement>;
    private allFocusable;
    private isBelowSidebarWidth: boolean;

    constructor(props) {
        super(props);
        this.activeSidebarRef = React.createRef<HTMLElement>();
        this.isBelowSidebarWidth = isBelowSidebarWidth();
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleTabsandEsc.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleTabsandEsc.bind(this));
    }

    componentDidUpdate(nextProps: IProps) {
        if (this.activeSidebarRef.current) {
            this.allFocusable = this.getAllFocusable();

            // If the sidebar has changed, move focus to the first item in the current sidebar (a heading with tabindex of -1)
            if (this.props.visibleChildKey !== nextProps.visibleChildKey && this.props.isMobile) {
                this.getHeadingTarget()?.focus();
            }
        }
    }

    private getHeadingTarget() {
        return this.activeSidebarRef.current.querySelector('[tabindex="-1"]') as HTMLElement;
    }

    private getAllFocusable() {
        return [].slice.call(this.activeSidebarRef.current.querySelectorAll('input, button, a')) as HTMLInputElement[]|HTMLButtonElement[]|HTMLAnchorElement[];
    }

    private handleTabsandEsc(e: KeyboardEvent) {
        if (this.props?.visibleChildKey && this.props.isMobile) {
            const pressed = e.code.toLowerCase();
            if (pressed === "escape") {
                this.props.closeOverlays();
            }
            else if (pressed === "tab" && e.shiftKey) {
                // backwards tab
                if (document.activeElement === this.allFocusable[0]) {
                    e.preventDefault();
                    this.allFocusable[this.allFocusable.length - 1].focus();
                }
            }
            else if (pressed === "tab") {
                // forwards tab
                if (document.activeElement === this.allFocusable[this.allFocusable.length - 1]) {
                    e.preventDefault();
                    this.allFocusable[0].focus();
                }
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.children.map(this.renderChild)}
            </React.Fragment>
        )
    }

    renderChild = (child: React.ReactElement<React.Props<any>>, index: number) => {
        const divClassName = 'seatmap-content-info ' + 'sidebar-' + index + (child && child.key === this.props.visibleChildKey ? ' filters-open' : '')
        return (
            // TEMP until we upgrade to a version of Typescript that includes "inert" attribute
            // @ts-ignore
            <div key={index} className={divClassName} inert={(child && child.key === this.props.visibleChildKey) || (this.isBelowSidebarWidth && !this.props.isMobile) ? null : ''} ref={child && child.key === this.props.visibleChildKey ? this.activeSidebarRef : null}>
                {child}
            </div>
        )

    }
}